import Auth from './auth';
import authConfig from './authConfig';

const { fetch: originalFetch } = window;

window.fetch = async (input, init) => {
  if (input.indexOf(authConfig.iumBaseUrl) !== -1)
    return await originalFetch(input, init);

  const username = new Auth().getProfile().email;
  const userNameHeader = {
    'x-user-name': username,
  };

  let existingHeaders = {};
  if (init?.headers instanceof Headers) {
    existingHeaders = Object.fromEntries(init.headers.entries());
  } else if (init?.headers) {
    existingHeaders = { ...init.headers };
  }

  const requestInit = {
    ...init,
    headers: {
      ...existingHeaders,
      ...userNameHeader,
    },
  };

  console.debug(`[Fetch Interceptor Frontend] ${input} - user: ${username}`);

  return await originalFetch(input, requestInit);
};
